// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": require("gatsby-module-loader?name=component---node-modules-gatsby-plugin-offline-app-shell-js!/opt/build/repo/node_modules/gatsby-plugin-offline/app-shell.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-actualday-js": require("gatsby-module-loader?name=component---src-pages-actualday-js!/opt/build/repo/src/pages/actualday.js"),
  "component---src-pages-actualgame-js": require("gatsby-module-loader?name=component---src-pages-actualgame-js!/opt/build/repo/src/pages/actualgame.js"),
  "component---src-pages-finals-js": require("gatsby-module-loader?name=component---src-pages-finals-js!/opt/build/repo/src/pages/finals.js"),
  "component---src-pages-groups-js": require("gatsby-module-loader?name=component---src-pages-groups-js!/opt/build/repo/src/pages/groups.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-page-2-js": require("gatsby-module-loader?name=component---src-pages-page-2-js!/opt/build/repo/src/pages/page-2.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "offline-plugin-app-shell-fallback.json": require("gatsby-module-loader?name=path---offline-plugin-app-shell-fallback!/opt/build/repo/.cache/json/offline-plugin-app-shell-fallback.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "actualday.json": require("gatsby-module-loader?name=path---actualday!/opt/build/repo/.cache/json/actualday.json"),
  "actualgame.json": require("gatsby-module-loader?name=path---actualgame!/opt/build/repo/.cache/json/actualgame.json"),
  "finals.json": require("gatsby-module-loader?name=path---finals!/opt/build/repo/.cache/json/finals.json"),
  "groups.json": require("gatsby-module-loader?name=path---groups!/opt/build/repo/.cache/json/groups.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "page-2.json": require("gatsby-module-loader?name=path---page-2!/opt/build/repo/.cache/json/page-2.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js